import type { ColumnDef } from "@tanstack/react-table";
import { Typography } from "@/components/ui/atoms/Typography";
import { dataTableSortHeader } from "@/components/ui/molecules/DataTable";
import type { WorkspaceProfileTableRow } from "@/types/workspace-profile.types";

export const workspaceProfileTableColumns: ColumnDef<WorkspaceProfileTableRow>[] = [
  
  {
    accessorKey: "company",
    meta: { label: "Company" },
    header: dataTableSortHeader("Company"),
    size: 180,
    minSize: 100,
    cell: ({ row }) => {
      const company = String(row.getValue("company") ?? "");
      return (
        <Typography variant="body-sm" weight="medium" color="secondary" title={company}>
          {company}
        </Typography>
      );
    },
  },
  {
    accessorKey: "fullName",
    meta: { label: "Name" },
    header: dataTableSortHeader("Name"),
    size: 200,
    minSize: 120,
    cell: ({ row }) => {
      const name = String(row.getValue("fullName") ?? "");
      return (
        <Typography variant="body-sm" weight="medium" color="secondary" title={name}>
          {name}
        </Typography>
      );
    },
  },
  {
    accessorKey: "email",
    meta: { label: "Email" },
    header: dataTableSortHeader("Email"),
    size: 240,
    minSize: 160,
    cell: ({ row }) => {
      const email = String(row.getValue("email") ?? "");
      return (
        <Typography variant="body-sm" weight="medium" color="secondary" title={email}>
          {email}
        </Typography>
      );
    },
  },
  {
    accessorKey: "jobTitle",
    meta: { label: "Job title" },
    header: dataTableSortHeader("Job title"),
    size: 160,
    minSize: 96,
    cell: ({ row }) => {
      const job = String(row.getValue("jobTitle") ?? "");
      return (
        <Typography variant="body-sm" weight="medium" color="secondary" title={job || undefined}>
          {job}
        </Typography>
      );
    },
  },
  {
    accessorKey: "phone",
    meta: { label: "Phone" },
    header: dataTableSortHeader("Phone"),
    size: 140,
    minSize: 88,
    cell: ({ row }) => {
      const phone = String(row.getValue("phone") ?? "");
      return (
        <Typography variant="body-sm" weight="medium" color="secondary" title={phone || undefined}>
          {phone}
        </Typography>
      );
    },
  },
];
